const ROUTES_NAME = {
    LOGIN: '/',
    INSTRUCTION: '/instructions',
    DASHBOARD: '/myexam',
    REGISTRATION: '/faceregistration',
    FACE_VERIFICATION: '/face-verification',
    TEST: '/test',
    THANK_YOU:'/thankyou',
    EXAM_SCORE:'/exam-score',
    AUTH_ERROR:'/auth-error'
  };
  
  export default ROUTES_NAME;
  